import { Button, Modal } from '@dev-spendesk/grapes';
import { type Dispatch, type SetStateAction } from 'react';

import {
  type AccountingSoftware,
  hasIntegrationFileBasedExport,
} from 'modules/bookkeep/integration/status';
import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { type DefaultEmployeeAccount } from '../../../../../../../accounting/employeeAccount';

interface Props {
  integration: AccountingSoftware;
  isOpen: boolean;
  setModalState: Dispatch<
    SetStateAction<{ kind: 'closed' | 'confirmEdit' | 'confirmDelete' }>
  >;
  onSetDefault: (
    defaultEmployeeAccount: DefaultEmployeeAccount,
  ) => Promise<void>;
  defaultEmployeeAccount: DefaultEmployeeAccount | undefined;
  newDefaultEmployeeAccount: DefaultEmployeeAccount;
}

export const EmployeeAccountDefaultEditConfirmationModal = ({
  integration,
  isOpen,
  setModalState,
  onSetDefault,
  defaultEmployeeAccount,
  newDefaultEmployeeAccount,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      title={t(
        'bookkeep.integrations.settings.employeeAccountsTable.confirmDefaultEditTitle',
        {
          codeFrom: defaultEmployeeAccount
            ? defaultEmployeeAccount.generalAccountCode
            : '',
          codeTo: newDefaultEmployeeAccount
            ? newDefaultEmployeeAccount.generalAccountCode
            : '',
        },
      )}
      subtitle={
        hasIntegrationFileBasedExport(integration)
          ? t('bookkeep.integrations.fileBased.confirmDeleteDescription')
          : t(
              'bookkeep.integrations.settings.employeeAccountsTable.confirmDefaultEditSubtitle',
              {
                code: defaultEmployeeAccount
                  ? defaultEmployeeAccount.generalAccountCode
                  : '',
              },
            )
      }
      isOpen={isOpen}
      iconVariant="warning"
      iconName="pen"
      actions={[
        <Button
          key="cancel"
          onClick={() => setModalState({ kind: 'closed' })}
          text={t('misc.cancel')}
          variant="secondaryNeutral"
        />,
        <Button
          key="yes"
          onClick={() => {
            onSetDefault(newDefaultEmployeeAccount);
            setModalState({ kind: 'closed' });
          }}
          text={t(
            'bookkeep.integrations.settings.expenseAccountsTable.confirmEdition',
          )}
          variant="primaryWarning"
        />,
      ]}
    />
  );
};
